import { SystemUsersClient } from 'api/swagger/ApiClient';
import { autoinject, bindingMode, customElement } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { SystemUserWrapper } from 'model/support-types';
import { ToastFormat, ToastHelper, ToastType } from 'support/toaster';

@autoinject
@customElement('administrators-panel')
export class AdministratorsPanelCustomElement {
  @bindable administrators: SystemUserWrapper[] = [];
  @bindable filterText: string = null;
  newEmptySystemUserWrapper: SystemUserWrapper = { user: null, userId: null };
  @bindable({ defaultBindingMode: bindingMode.fromView }) isAdministratorEditing = false;

  constructor(private api: SystemUsersClient, private toastHelper: ToastHelper) {
  }

  addNewAdministrator(item: SystemUserWrapper): Promise<void> {
    return this.api.addAdministrator(item.user.uniqueid)
      .then((dto) => {
        item.userId = dto.id;
        this.administrators.unshift(item);
        this.administrators = this.administrators.sort((a, b) => ('' + a.user.name).localeCompare(b.user.name));
        this.toastHelper.toast('Administrator has been <b>added</b>.', 'Administrator added', ToastType.Success, ToastFormat.Html);
      });
  }

  removeAdministrator(item: SystemUserWrapper): Promise<void> {
    return this.api.removeAdministrator(item.userId)
      .then((dto) => {
        this.administrators.splice(this.administrators.indexOf(item), 1);
        this.toastHelper.toast('Administrator has been <b>removed</b>.', 'Administrator removed', ToastType.Success, ToastFormat.Html);
      });
  }
}
